// İSG uzmanı portalı — değeri geciktiren küçük hook (arama kutusu → istek gürültüsü
// azaltma). Her tuş vuruşunda değil, yazım durduktan `delay` ms sonra günceller.

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delay = 350): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
